<script lang="ts">
  export let click;
  export let text = 'Supprimer';
  let hasBeenClicked = false;
</script>

{#if !hasBeenClicked}
  <button class="button is-danger is-inverted" on:click={() => hasBeenClicked = true}>{text}</button>
{:else}
  <button class="button is-danger" on:click={click}>Confirmer</button>
  <button class="button is-white" on:click={() => hasBeenClicked = false}>Annuler</button>
{/if}